import { IStyleProps } from "@mindmemobile/mm-shared-global";
import styled from "styled-components";

export const NavpillContainer = styled.div<IStyleProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  // apply this class to center the navpills irrespective of the third div
  // and add position-relative class to the parent div
  &.navpills-centered {
    position: absolute; /* Ensures it's centered relative to the page */
    left: 50%;
    transform: translateX(-50%);
    text-align: center;
    line-height: 100px;
  }
  .nav-tabs.nav-fill {
    border-bottom: none;
  }
  .nav-item {
    a {
      font-size: 14px;
      font-weight: 600;
      color: ${(props) => props.bgColor || "#556bb8"};
      padding: 12px 30px;
      border: 1px solid ${(props) => props.bgColor || "#556bb8"};
      border-radius: 0px;
      line-height: 14px;
    }
    &:not(:first-child, :last-child) a {
      border-radius: 0px;
      border-left: 0;
      border-right: 0;
      &.active,
      &:hover,
      &:focus {
        background-color: ${(props) => props.bgColor || "#556bb8"};
        color: #ffffff;
        border: 1px solid ${(props) => props.bgColor || "#556bb8"};
        border-left: 0px;
        border-right: 0px;
      }
    }
    a.active,
    a:hover,
    a:focus {
      background-color: ${(props) => props.bgColor || "#556bb8"};
      color: #ffffff;
      border: 1px solid ${(props) => props.bgColor || "#556bb8"};
    }
    &:first-child a {
      border-radius: 25px 0px 0px 25px;
    }
    &:last-child a {
      border-radius: 0px 25px 25px 0px;
    }
    &:focus,
    &:focus-visible {
      outline: none;
    }
    a:focus-visible {
      box-shadow: none;
    }
  }
  @media (max-width: 480px) {
    .nav-item {
      a {
        font-size: 13px;
      }
    }
  }
`;
